import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as PopupActions from '../../actions/popup';
import { connect } from 'react-redux';
import { links } from '../../constants/links';
import { showAppLegacyCompanyId } from '../../utils/utils';

class MobileAppSelectorPopup extends Component {
  constructor(props) {
    super(props);
    this.bindFunctions();
  }

  bindFunctions() {
    this.pickCountryToRedirect = this.pickCountryToRedirect.bind(this);
  }

  locale(id, options) {
    const { intl } = this.props;
    const { formatMessage } = intl;

    return formatMessage({ id }, options);
  }

  getFlags() {
    const {
      brand: {
        branded: { mapCountries = {} }
      },
      popup,
      profileCompanyIds
    } = this.props;

    const flags = Object.keys(mapCountries).reduce((ret, isoCode) => {
      const { [isoCode]: isoCountry } = mapCountries || {};
      const { companyId, iconUrl } = isoCountry || {};

      if (popup.step_AddAccount_IsVisible && profileCompanyIds) {
        if (profileCompanyIds.includes(companyId)) return ret;
      }

      if (companyId) {
        ret.push(
          <li onClick={() => this.pickCountryToRedirect(companyId)} key={isoCode}>
            <i style={{ backgroundImage: `url(${iconUrl})` }} />
            <span>{this.locale('iso__' + isoCode)}</span>
          </li>
        );
      }

      return ret;
    }, []);

    return flags;
  }

  pickCountryToRedirect(companyId) {
    const { popup_MobileAppSelector_SetVisibility, appType } = this.props;

    const isLegacy = showAppLegacyCompanyId(companyId);

    let linkToOpen;

    if (appType === 'ios') {
      linkToOpen = isLegacy ? links.legacyAppLinkApple : links.appStoreLink;
    } else {
      linkToOpen = isLegacy ? links.legacyAppLinkPlay : links.playStoreLink;
    }

    if (linkToOpen) {
      window.open(linkToOpen, '_blank');
    }

    popup_MobileAppSelector_SetVisibility(false);
  }

  render() {
    const {
      brand: {
        branded: { mapCountries = {} }
      }
    } = this.props;

    const flags = this.getFlags();

    if (flags.length === 0) {
      return (
        <div className="mobile-app-selector-popup">
          <div className="text-center f-25 mt-40 mb-10">
            <FormattedMessage id="no_apps_available" />
          </div>
        </div>
      );
    }

    return (
      <div className="mobile-app-selector-popup">
        <div className="text-center f-25 mt-40 mb-10">
          <FormattedMessage id="select.country.for.app.deeplinks" />
        </div>
        <div className="text-center mb-35">
          <ul className="flag-country-selector">{flags}</ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    brand: state.brand,
    popup: state.popup,
    profileCompanyIds: state.user?.profileCompanyIds,
    appType: state.popup?.mobileAppSelectorType
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...PopupActions }, dispatch);
}

const connectComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileAppSelectorPopup);

export default injectIntl(connectComponent);
